import axios from "axios";
import { config } from "./config";
import { toast } from "react-toastify";
import { navigateUrls } from "./staticOptions";
import { removeItemToLocalStorage } from "./services";

export const axiosApi = axios.create({
  baseURL: config.API_URL,
});

// Set default headers if token exists
if (typeof window !== "undefined") {
  const token = localStorage.getItem("_token");
  if (token) {
    axiosApi.defaults.headers.common["x-titter-api-access-key"] = `Bearer ${token}`;
  }
}

// Add requesttoken header
axiosApi.defaults.headers.common["requesttoken"] = process.env.NEXT_PUBLIC_REQUEST_TOKEN || "sustanix-local-request-token";

const handleSuccess = (response) => {
  return response;
};

const handleError = (error) => {
  console.log({ error });
  const status = error?.response?.status;
  const message = error?.response?.data?.message || error.message;

  switch (status) {
    case 500:
      console.log("/500");
      toast.error(message);
      break;
    case 401:
      if (error?.response?.data?.responseCode === 0) {
        console.log("/401");
        removeItemToLocalStorage("_token");
        if (typeof window !== "undefined") {
          window.location = "/login";
        }
      }
      toast.error(message);
      break;
    default:
      toast.error(message);
      break;
  }
  return Promise.reject(error.response);
};

axiosApi.interceptors.response.use(handleSuccess, handleError);

export default axiosApi;
